import React from 'react';
import AdminPanel from '../components/admin/AdminPanel';

export default function AdminPage() {
  return <AdminPanel />;
}
